/**
 * @Author:
 * @Description:
 * @DateTime: Created in 18:46 2019-07-10
 */

import {Integer} from "../types/base";

/**
 * 枚举类别
 */
export default class EnumItem {
	constructor (name: string = '', id: Integer = null, code: string = '') {
		this.name = name
        this.id = id
        this.code = code
	}

	private name: string
	private id: Integer
	private code: string

	getId (): number {
		return this.id as number
	}

	getName (): string {
		return this.name
    }
    
    getCode (): string {
		return this.code
	}
}

export let enumMixn = {
    
	findId(id):EnumItem {
		for (let k in this) {
			if(this[k] instanceof EnumItem && this[k].id === id) {
				return this[k]
			}
		}
		return new EnumItem('', null)
    },
    findCode(code):EnumItem {
		for (let k in this) {
			if(this[k] instanceof EnumItem && this[k].code === code) {
				return this[k]
			}
		}
		return new EnumItem('', null)
	},
	findName(name):EnumItem {
		for (let k in this) {
			if(this[k] instanceof EnumItem && this[k].name === name) {
				return this[k]
			}
		}
		return new EnumItem('', null)
	},
	getList():{id: number, name: string, code: string, getName(): string, getCode(): string, getId(): string}[] {
		let arr:{id: number, name: string, code: string, getName(): string, getCode(): string, getId(): string}[] = []
		for (let k in this) {
			if(this[k] instanceof EnumItem ) {
				arr.push(this[k])
			}
		}
		return arr
	}
}

